module.exports = __webpack_public_path__ + "img/akar-icons_file.23cfa9c6.svg";